import React, { useEffect } from "react";

import { Grid, makeStyles, Menu } from "@material-ui/core";
import { Text, SVG, Input, Button } from "sunrise-ui";
import "./MachineCard.scss";
import ImageInputComponent from "../../utilities/ImageInputComponent";
import { postUpsertMachineDoc } from "../../redux/reducers/machineReducers";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../redux/store";
import { useSelector } from "react-redux";
import Loader from "../../utilities/Loader";
import { CSVLink } from "react-csv";

const useStylesForPopUp = makeStyles({
  customWidth: {
    "& .MuiMenu-list": {
      width: "280px !important",
      border: "1px solid #5F67E0",
      borderRadius: "8px",
    },
  },
});

//-------For restricting data input---------
const alphaNumbericRegex = /^[a-zA-Z0-9]+$/;

const displayDate = (dateString: string) => {
  if (dateString) {
    const date = new Date(dateString);
    const month = date.toLocaleString("default", { month: "short" });
    const day = `0${date.getDate()}`.slice(-2);
    return `${day} ${month}, ${date.getFullYear()}`;
  }
  return "";
};

const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  const month = `0${date.getMonth() + 1}`.slice(-2);
  const day = `0${date.getDate()}`.slice(-2);
  return `${date.getFullYear()}-${month}-${day}`;
};

const AddMachineDrawer = (props: any) => {
  const dispatch = useDispatch<AppDispatch>();
  const { drawerData, toggleDrawer, reloadData } = props;
  const upsertDocument = useSelector(
    (state: any) => state.MACHINE.upsertDocument
  );
  const viewMachineData = useSelector(
    (state: any) => state?.MACHINE?.viewMachineData
  );
  const [dataToDownload, setDataToDownload] = React.useState([]);
  //----------for module data------------
  const [oldIdentifier, setOldIdentifier] = React.useState("");
  const [identifier, setIdentifier] = React.useState("");
  const [identifierErr, setIdentifierErr] = React.useState(false);
  const [issueDate, setIssueDate] = React.useState("");
  const [issueDateErr, setIssueDateErr] = React.useState(false);
  const [expiryDate, setExpiryDate] = React.useState("");
  const [expiryDateErr, setExpiryDateErr] = React.useState(false);
  const [expiryDateErrMsg, setExpiryDateErrMsg] = React.useState("");

  // ----------for img upload-------------
  const [moduleImg, setModuleImg] = React.useState<File | null>();
  const [moduleImgName, setModuleImgName] = React.useState("");
  const [moduleImgErr, setModuleImgErr] = React.useState(false);

  const [isEdit, setIsEdit] = React.useState(false);

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const classes = useStylesForPopUp();

  //-------For displaying loader---------
  const [isLoadingButton, setIsLoadingButton] = React.useState(false);

  useEffect(() => {
    reloadData(drawerData.machineId);
    // eslint-disable-next-line
  }, [upsertDocument]);

  const handleAnchorSelect = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleEdit = (event: React.MouseEvent<HTMLButtonElement>) => {
    const index = drawerData.data.length - 1;
    setOldIdentifier(drawerData.data[index].identifier);
    setIdentifier(drawerData.data[index].identifier);
    setIssueDate(drawerData.data[index].issueDate ? formatDate(drawerData.data[index].issueDate) : "");
    setExpiryDate(drawerData.data[index].expiryDate ? formatDate(drawerData.data[index].expiryDate) : "");
    setModuleImg(drawerData.data[index].photo);
    setModuleImgName(drawerData.data[index].photo);
    setModuleImgErr(false);
    setIsEdit(true);
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleCancel();
  };

  const handlePopUpCancel = () => {
    handleMenuClose();
  };

  const handlePopUpSubmit = () => {
    if (validateData()) {
      setIsLoadingButton(true);
      let imgUri = `${
        process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_DEV_URL
          : process.env.REACT_APP_PRO_URL
      }/images/`;

      const obj: any = {
        machineId: drawerData.machineId,
        type: drawerData.module.toUpperCase(),
        newIdentifier: identifier,
        issueDate: issueDate,
        expiryDate: expiryDate,
        docPhoto:
          moduleImgName?.indexOf(imgUri) > -1
            ? moduleImgName
            : `${imgUri}${moduleImgName}`,
      };

      if (isEdit) {
        obj.oldIdentifier = oldIdentifier;
      }

      dispatch(
        postUpsertMachineDoc({
          endPoint: "machine/document",
          data: obj,
        })
      ).then((res) => {
        setIsLoadingButton(false);
      });
      handleMenuClose();
      //  --went to modal yes button handler--
    }
  };

  const validateData = () => {
    let passed = true;
    if (identifier === undefined || identifier === "") {
      setIdentifierErr(true);
      passed = false;
    }
    if (issueDate === undefined || issueDate === "") {
      setIssueDateErr(true);
      passed = false;
    } else if (expiryDate !== undefined && expiryDate !== "") {
      let expectedDate = new Date(issueDate);
      let actualDate = new Date(expiryDate);
      let expectedTime = "";
      switch (drawerData.module) {
        case "RC":
          expectedDate.setFullYear(expectedDate.getFullYear() + 15);
          expectedTime = "15 years";
          break;
        case "TPI":
          expectedDate.setMonth(expectedDate.getMonth() + 6);
          expectedTime = "6 months";
          break;
        case "Insurance":
          expectedDate.setFullYear(expectedDate.getFullYear() + 1);
          expectedTime = "1 year";
          break;
        case "PUC":
          expectedDate.setFullYear(expectedDate.getFullYear() + 1);
          expectedTime = "1 year";
          break;
      }
      if (actualDate < expectedDate) {
        setExpiryDateErr(true);
        setExpiryDateErrMsg(
          `Expiry Date should be min of ${expectedTime} from Issue date`
        );
        passed = false;
      }
    }
    if (expiryDate === undefined || expiryDate === "") {
      setExpiryDateErr(true);
      setExpiryDateErrMsg("");
      passed = false;
    }
    if (moduleImg === undefined || moduleImg === null) {
      setModuleImgErr(true);
      passed = false;
    }
    return passed;
  };

  const handleCancel = () => {
    setIdentifier("");
    setIdentifierErr(false);
    setIssueDate("");
    setIssueDateErr(false);
    setExpiryDate("");
    setExpiryDateErr(false);
    setExpiryDateErrMsg("");
    setModuleImg(null);
    setModuleImgName("");
    setModuleImgErr(false);
    setIsEdit(false);
  };

  const getUpdateNotificationDate = () => {
    if (drawerData?.data[0]?.expiryDate) {
      const filteredDates = drawerData.data.filter(function (a: any) {
        const today = new Date();
        const expiryDate = new Date(a.expiryDate);
        return expiryDate > today;
      });
      const min = filteredDates.reduce(function (a: any, b: any) {
        return a.expiryDate < b.expiryDate ? a : b;
      });
      return min.expiryDate;
    }
    return "";
  };

  const displayHistory = () => {
    return (
      drawerData?.data?.length &&
      drawerData?.data?.map((item: any, index: number) => (
        <Grid
          key={`${drawerData.module}_HISTORY_${index}`}
          item
          xs={12}
          container
          spacing={1}
          className="right_drawer_details_container"
        >
          {index > 0 && <hr />}
          {/* ---------Number--------- */}
          <Grid item xs={12}>
            <Text
              type="normal"
              fonts="normal"
              fontSize={14}
              className="mb0 mt0"
            >
              <span className="fw400">{`${drawerData.module} ${
                index + 1
              } Number`}</span>
              <span className="float-right">{item?.identifier}</span>
            </Text>
          </Grid>
          {/* ---------Issue Date--------- */}
          <Grid item xs={12}>
            <Text
              type="normal"
              fonts="normal"
              fontSize={14}
              className="mb0 mt0"
            >
              <span className="fw400">{`${drawerData.module} ${
                index + 1
              } Issue Date`}</span>
              <span className="float-right">
                {item?.issueDate ? displayDate(item?.issueDate) : ""}
              </span>
            </Text>
          </Grid>
          {/* ----------Expiry Date----------- */}
          <Grid item xs={12}>
            <Text
              type="normal"
              fonts="normal"
              fontSize={14}
              className="mb0 mt0"
            >
              <span className="fw400">{`${drawerData.module} ${
                index + 1
              } Expiry Date`}</span>
              <span className="float-right">
                {item?.expiryDate ? displayDate(item?.expiryDate) : ""}
              </span>
            </Text>
          </Grid>

          {/* ----------Added On----------- */}
          <Grid item xs={12}>
            <Text
              type="normal"
              fonts="normal"
              fontSize={14}
              className="mb0 mt0"
            >
              <span className="fw400">Added On</span>
              <span className="float-right">
                {displayDate(item?.createdAt)}
              </span>
            </Text>
          </Grid>
        </Grid>
      ))
    );
  };
  //-----------------------------Download----------------------------
  useEffect(() => {
    const downloadData =
      drawerData?.data &&
      drawerData?.data.map((item: any, index: number) => {
        return {
          "Machine Name": viewMachineData?.number,
          Serial: `${drawerData?.module} ${index + 1}`,
          Number: item?.identifier === null ? "" : item?.identifier,
          "Issue Date":
            item?.issueDate === null ? "" : displayDate(item?.issueDate),
          "Expiry Date":
            item?.expiryDate === null ? "" : displayDate(item?.expiryDate),
        };
      });
    setDataToDownload(downloadData);
  }, [drawerData, viewMachineData]);

  return (
    <Grid className="add_machine_wrapper">
      <div className="right_drawer_page">
        <Grid container className="drwaer_container p1">
          <Grid item xs={11}>
            <Text
              type="normal"
              fonts="normal"
              fontSize={18}
              className="mb0 mt0 capitalize"
            >
              {`View/Add New/Edit ${drawerData.module}`}
            </Text>
          </Grid>
          <Grid
            item
            xs={1}
            className="pointer"
            onClick={() => toggleDrawer(false)}
          >
            <SVG type={"close"} />
          </Grid>

          {/* -----------------------Module History detail---------- ------------*/}
          <Grid
            item
            xs={12}
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Text
              type="normal"
              fonts="normal"
              fontSize={18}
              className="mb1 mt1"
            >
              {`${drawerData.module} History Details`}
            </Text>
            <div className="pointer">
              <CSVLink data={dataToDownload} filename="history">
                <SVG type={"download"} isActive={true} />
              </CSVLink>
            </div>
          </Grid>

          {drawerData.data && displayHistory()}
          {drawerData.data && (
            <Grid
              item
              xs={12}
              container
              spacing={1}
              className="right_drawer_details_container"
            >
              <Grid item xs={12}>
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={14}
                  className="mb0 mt1"
                >
                  <span className="fw400">Update Required Before</span>
                  <span className="float-right" style={{ color: "#961b01" }}>
                    {displayDate(getUpdateNotificationDate())}
                  </span>
                </Text>
              </Grid>
            </Grid>
          )}

          {/* -------Buttons------ */}
          <Grid item xs={8}>
            <Grid className="d-flex mt2">
              <Button
                type="button"
                size="medium"
                isRounded={true}
                category="primary"
                onClick={handleAnchorSelect}
                className="f14 mr-1"
              >
                +Add New
              </Button>
              <Button
                type="button"
                size="medium"
                isRounded={true}
                category="border-only"
                onClick={handleEdit}
                className="f14"
              >
                Edit
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </div>

      {/* ------------Popup Menu------ */}
      <Grid item xs={12}>
        <Menu
          id="pileSteps-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          className={classes.customWidth}
        >
          <Grid container className="p1">
            <Grid item xs={12}>
              <Text
                type="normal"
                fonts="normal"
                fontSize={18}
                className="mb1 mt0"
              >
                <span className="fw500">{`${isEdit ? "Edit" : "New"} ${
                  drawerData.module
                }`}</span>
              </Text>
            </Grid>
            <Grid item xs={12}>
              <Grid className="mb">
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={16}
                  className="mb mt0"
                >
                  <span className="fw500">{`${isEdit ? "Edit" : "New"} ${
                    drawerData.module
                  } Number`}</span>
                </Text>
                <Input
                  color={identifierErr ? "danger" : "primary"}
                  fonts="normal"
                  placeholder="Enter Here"
                  value={identifier}
                  type="text"
                  onChange={(e: any) => {
                    if (
                      e.target.value === "" ||
                      alphaNumbericRegex.test(e.target.value)
                    ) {
                      setIdentifier(e.target.value);
                      setIdentifierErr(false);
                    }
                  }}
                />
                <Text
                  type={identifierErr ? "danger" : "normal"}
                  fonts="normal"
                  fontSize={12}
                  className={identifierErr ? "mb0 mt0" : "d-none"}
                >
                  {`Please Enter ${drawerData.module} Number`}
                </Text>
              </Grid>
            </Grid>
            {/* -------Issue date field------ */}
            <Grid item xs={12}>
              <Text
                type="normal"
                fonts="normal"
                fontSize={16}
                className="mb mt0-5"
              >
                <span className="fw500">{`${
                  isEdit ? "Edit" : "New"
                } Issue Date*`}</span>
              </Text>
              <Input
                color={issueDateErr ? "danger" : "primary"}
                fonts="normal"
                placeholder="Enter Here"
                value={issueDate}
                type="date"
                onChange={(e) => {
                  setIssueDate(e.target.value);
                  setIssueDateErr(false);
                }}
              />
              <Text
                type={issueDateErr ? "danger" : "normal"}
                fonts="normal"
                fontSize={12}
                className={issueDateErr ? "mb0 mt0" : "d-none"}
              >
                {`Please Select ${drawerData.module} Issue Date`}
              </Text>
            </Grid>
            {/* -------Expiry date field------ */}
            <Grid item xs={12}>
              <Text
                type="normal"
                fonts="normal"
                fontSize={16}
                className="mb mt1"
              >
                <span className="fw500">{`${
                  isEdit ? "Edit" : "New"
                } Expiry Date*`}</span>
              </Text>
              <Input
                color={expiryDateErr ? "danger" : "primary"}
                fonts="normal"
                placeholder="Enter Here"
                value={expiryDate}
                type="date"
                min={issueDate}
                onChange={(e) => {
                  setExpiryDate(e.target.value);
                  setExpiryDateErr(false);
                }}
              />
              <Text
                type={expiryDateErr ? "danger" : "normal"}
                fonts="normal"
                fontSize={12}
                className={expiryDateErr ? "mb0 mt0" : "d-none"}
              >
                {expiryDateErrMsg
                  ? expiryDateErrMsg
                  : `Please Select ${drawerData.module} Expiry Date`}
              </Text>
            </Grid>
            {/* --------Module photo------- */}
            <Grid item xs={12}>
              <Grid item xs={6}>
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={16}
                  className="mb mt1"
                >
                  <span className="fw500">{`${isEdit ? "Edit" : "New"} ${
                    drawerData.module
                  } Photo*`}</span>
                </Text>
                <Grid className="file_upload_box">
                  <ImageInputComponent
                    setValue={setModuleImg}
                    setImageName={setModuleImgName}
                    value={moduleImg}
                    bind={`${isEdit ? "edit" : "new"}${drawerData.module}Img`}
                    setErr={setModuleImgErr}
                    isEdit={isEdit}
                    imageChanged={false}
                  />
                </Grid>
                <Text
                  type={moduleImgErr ? "danger" : "normal"}
                  fonts="normal"
                  fontSize={12}
                  className={moduleImgErr ? "mb0 mt0" : "d-none"}
                >
                  Please upload Photo
                </Text>
              </Grid>
            </Grid>
            <Grid container className="mt2" xs={12}>
              <Grid item xs={12}>
                <Grid className="d-flex mt2">
                  <Button
                    type="button"
                    size="medium"
                    isRounded={true}
                    category="border-only"
                    onClick={() => {
                      // handleModal("unassign", row?._id, row);
                      handlePopUpCancel();
                    }}
                    className="f14 mr-1"
                  >
                    Cancel
                  </Button>
                  <Button
                    type="button"
                    size="medium"
                    isRounded={true}
                    category="primary"
                    onClick={() => {
                      // handleModal("unassign", row?._id, row);
                      handlePopUpSubmit();
                    }}
                    className="f14"
                  >
                    {isLoadingButton ? (
                      <Loader
                        color="#fff"
                        loading={isLoadingButton}
                        size={8}
                        height="auto"
                      />
                    ) : (
                      "Submit"
                    )}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Menu>
      </Grid>
    </Grid>
  );
};

export default AddMachineDrawer;
